import { render, staticRenderFns } from "./ServerLimits.vue?vue&type=template&id=503b0baf&"
import script from "./ServerLimits.vue?vue&type=script&lang=js&"
export * from "./ServerLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports